// extracted by mini-css-extract-plugin
module.exports = {"completed-workflow":"styles_completed-workflow__1z42S","download":"styles_download__1KPzg","highlight":"styles_highlight__2GuO-"};